import { useEffect } from "react";

import useSegmentTrackEvent from "../../../utils/useSegmentTrackEvent";
import { Allocation } from "./Allocation";
import { useAllocationSetup } from "./hooks/useAllocationSetup";
import { trackAllocationEvent } from "./utils";

export const AllocationsCreate = () => {
  const { trackEvent } = useSegmentTrackEvent();
  useAllocationSetup();

  useEffect(() => {
    trackAllocationEvent({
      trackEvent,
      eventName: "Allocation Rule Opened",
      ruleCount: 0,
      hasUnallocated: false,
    });
  }, [trackEvent]);

  return <Allocation />;
};
